/** Thinking levels the Operations pickers offer (9 Oct 2026: Ultracode removed from
 *  every picker). A stored "low" is still shown as Low; a legacy stored "ultra" /
 *  "ultracode" (or anything unknown) is shown and treated as Max — never blank. */
export type OfferedEffort = "medium" | "high" | "xhigh" | "max";
export type ShownEffort = "low" | OfferedEffort;

export const OFFERED_EFFORTS: readonly OfferedEffort[] = ["medium", "high", "xhigh", "max"];

export const EFFORT_LABEL: Record<ShownEffort, string> = {
  low: "Low", medium: "Medium", high: "High", xhigh: "xHigh", max: "Max",
};

/** The level a picker shows as selected. Missing → the backend default (xHigh). */
export function shownEffort(level: unknown, fallback: ShownEffort = "xhigh"): ShownEffort {
  if (level === undefined || level === null || level === "") return fallback;
  const v = String(level).trim().toLowerCase();
  if (v === "low" || v === "medium" || v === "high" || v === "xhigh" || v === "max") return v;
  // Legacy "ultra" / "ultracode" (the retired Ultracode tier) and any unknown value.
  return "max";
}

export function effortLabel(level: unknown, fallback: ShownEffort = "xhigh"): string {
  return EFFORT_LABEL[shownEffort(level, fallback)];
}

/** Response footer text: an older saved "Ultracode" / "Ultra" segment reads as Max. */
export function footerEffortLabel(label: string | undefined): string | undefined {
  if (!label) return label;
  return /^ultra(code)?$/i.test(label.trim()) ? "Max" : label;
}
